import { useEffect } from "react";

import { EmptystatePuzzleColored } from "components/icons/generated";
import EmptyState from "ds/components/EmptyState";
import useErrorHandle from "hooks/useErrorHandle";
import useSearchIntentResources from "shared/IntentProject/useSearchIntentResources";
import { IntentProject } from "types/generated";
import useSearchIntentResourcesSuggestions from "shared/IntentProject/useSearchIntentResourcesSuggestions";
import useTitle from "hooks/useTitle";

import IntentProjectResourcesTable from "./Table";
import useIntentProjectResourcesHierarchyStore from "./Table/useResourcesHierarchyStore";

type IntentProjectResourcesProps = {
  intentProject: IntentProject;
};

const IntentProjectResources = ({ intentProject }: IntentProjectResourcesProps) => {
  const { allResourcesCount } = useSearchIntentResourcesSuggestions(intentProject.id);
  const { resources, initialLoading, isEmpty, error, startCursor, endCursor, paginationResetKey } =
    useSearchIntentResources(intentProject.id);

  const resetResourcesHierarchy = useIntentProjectResourcesHierarchyStore((state) => state.reset);

  useEffect(() => {
    resetResourcesHierarchy();
  }, [intentProject.id, resetResourcesHierarchy]);

  useTitle(`Resources · ${intentProject.name}`);

  const ErrorContent = useErrorHandle(error);

  if (ErrorContent) {
    return ErrorContent;
  }

  if (isEmpty) {
    return (
      <EmptyState
        title="No resources yet"
        caption="Resources are created when you use MCP tools with this Intent Project. Each resource represents an interaction with your integrated cloud resources."
        icon={EmptystatePuzzleColored}
      />
    );
  }

  return (
    <IntentProjectResourcesTable
      resources={resources}
      loading={initialLoading}
      startCursor={startCursor}
      endCursor={endCursor}
      allItemsCount={allResourcesCount}
      resetKey={paginationResetKey}
    />
  );
};

export default IntentProjectResources;
